<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
  import emitter from '@/minxins/emitter'
  
  export default {
    name: "app-outline-content",
    mixins: [emitter],
    props: {
      label: {
        type: String,
        required: true
      },
      name: {
        type: String
      }
    },
    mounted() {
      this.dispatch('app-outline-main', 'app.outlineContent.addOutlineContent', [this]);
    }
  }
</script>

<style scoped>

</style>
